/* Clean Skin → Shopify bridge.
   The design keeps its own bag (localStorage 'cs_cart'). Every "order" path in the
   design ends in openCODItems(items); here that copies the items into the real
   Shopify cart and opens the EasySell COD form, which places the actual order. */
(function () {
  if (typeof window.openCODItems !== 'function' || typeof HANDLES === 'undefined') return;

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body || {}) });
  }

  // Variant for a design line, from the live catalog on the page (no extra request): [title, price, available, qty, id].
  var low = function (s) { return String(s || '').trim().toLowerCase(); };
  function pickVariant(l, opt) {
    var name = opt && (opt.name || opt);
    if (name) for (var k = 0; k < l.v.length; k++) if (low(l.v[k][0]) === low(name)) return l.v[k];
    for (var m = 0; m < l.v.length; m++) if (l.v[m][2]) return l.v[m];
    return null;
  }

  // Replace the Shopify cart with the design items in ONE request: /cart/update.js sets every listed
  // variant's quantity (0 removes the lines already in the cart, new ids are added).
  var cartVids = (window.__CS_CART || []).slice();
  function syncCart(items, clearIfEmpty) {
    var L = window.CS_LIVE_DATA || {}, updates = {}, lines = 0;
    cartVids.forEach(function (id) { updates[id] = 0; });
    items.forEach(function (it) {
      var h = it.p && HANDLES[it.p.id], l = h && L[h], v = l && pickVariant(l, it.opt);
      if (!v || !v[2]) return; // sold out: never send it, Shopify would still accept it
      updates[v[4]] = (updates[v[4]] || 0) + (it.qty || 1); lines++;
    });
    if (!lines && !(clearIfEmpty && cartVids.length)) return Promise.resolve(0);
    return post('/cart/update.js', { updates: updates }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (c) { cartVids = c.items.map(function (x) { return x.variant_id; }); return lines; });
  }

  // The Shopify cart mirrors the bag on every change (add, quantity, remove), a moment after it happens.
  // Shopify then reports real AddToCart events to Meta with the variant ID, and anything that reads the
  // Shopify cart sees exactly the bag. Orders still sync once more right before the form opens.
  var mirrorT;
  window.csShopifyMirror = function () {
    clearTimeout(mirrorT);
    mirrorT = setTimeout(function () {
      if (busy || typeof CART === 'undefined') return;
      var items = CART.filter(function (c) { return DATA.products[c.id]; }).map(function (c) { return { p: DATA.products[c.id], qty: c.qty, opt: c.opt ? { name: c.opt } : null }; });
      syncCart(items, true).catch(function () {});
    }, 400);
  };

  // Instant feedback while the cart is prepared: a small "opening" pill, gone as soon as EasySell shows.
  var pill;
  function loading(on) {
    if (!pill) {
      pill = document.createElement('div');
      pill.setAttribute('role', 'status');
      pill.style.cssText = 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%);z-index:2147483000;display:none;align-items:center;gap:10px;padding:12px 20px;border-radius:999px;background:var(--moss,#3d2b24);color:var(--cream,#f4eee6);font:500 15px/1 Outfit,system-ui,sans-serif;box-shadow:0 10px 30px rgb(0 0 0/.2)';
      pill.innerHTML = '<span style="width:16px;height:16px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:csSpin .7s linear infinite"></span>Opening your order…';
      var st = document.createElement('style'); st.textContent = '@keyframes csSpin{to{transform:rotate(360deg)}}'; document.head.appendChild(st);
      document.body.appendChild(pill);
    }
    pill.style.display = on ? 'flex' : 'none';
  }

  // EasySell paints its order button black with an inline !important style; repaint it in the brand colour,
  // and again whenever the app re-renders it.
  var brandBtn = function () {
    var b = document.getElementById('es-form-button'); if (!b || b.__cs) return;
    b.__cs = true;
    var paint = function () {
      var c = getComputedStyle(document.documentElement).getPropertyValue('--moss').trim() || '#3d2b24';
      obs.disconnect();
      b.style.setProperty('background-color', c, 'important');
      b.style.setProperty('border-radius', '999px', 'important');
      obs.observe(b, { attributes: true, attributeFilter: ['style'] });
    };
    var obs = new MutationObserver(paint);
    paint();
  };

  // An order from the bag empties the bag once EasySell confirms it. EasySell clears the Shopify cart right
  // after a successful order (POST /cart/clear.js); a page load that finds the Shopify cart empty means the same.
  var BAG = 'cs_bag_order';
  function orderPlaced() {
    var fromBag = null; try { fromBag = localStorage.getItem(BAG); localStorage.removeItem(BAG); } catch (e) {}
    if (fromBag && typeof CART !== 'undefined') { CART.length = 0; saveCart(); syncCount(); }
  }
  var nativeFetch = window.fetch;
  window.fetch = function (u) {
    var r = nativeFetch.apply(this, arguments);
    try { if (/\/cart\/clear\.js/.test(String((u && u.url) || u))) r.then(function (x) { if (x.ok) orderPlaced(); }, function () {}); } catch (e) {}
    return r;
  };
  if (!(window.__CS_CART || []).length) orderPlaced();

  var low2 = function (s) { return String(s || '').trim().toLowerCase(); };
  var busy = false;
  window.openCODItems = function (items, fromCart) {
    if (busy || !items || !items.length) return;
    var L = window.CS_LIVE_DATA || {};
    var liveOf = function (it) { return it.p && L[HANDLES[it.p.id]]; };
    // A product with sizes or shades and none chosen: ask, never guess.
    var need = items.filter(function (it) { var l = liveOf(it), n = it.opt && (it.opt.name || it.opt);
      return l && l.a && l.v.length > 1 && l.v.some(function (v) { return v[2]; }) && !(n && l.v.some(function (v) { return low2(v[0]) === low2(n); })); });
    if (need.length && typeof cartAdd === 'function') {
      if (items.length === 1) { openCart(); quickView(need[0].p.id, true); toast('Choose a size or shade first'); }
      else cartAdd(items.map(function (it) { return { id: it.p.id, qty: it.qty || 1, opt: it.opt ? it.opt.name || it.opt : null }; }));
      return;
    }
    // Nothing orderable: say so right away instead of after the loading pill.
    if (!items.some(function (it) { var l = liveOf(it), v = l && pickVariant(l, it.opt); return v && v[2]; })) {
      if (typeof toast === 'function') toast('Sorry, this is sold out right now');
      return;
    }
    try { fromCart ? localStorage.setItem(BAG, '1') : localStorage.removeItem(BAG); } catch (e) {}
    busy = true;
    loading(true);
    if (typeof closeCart === 'function') try { closeCart(); } catch (e) {}
    syncCart(items).then(function (added) {
      busy = false;
      if (!added) { loading(false); if (typeof toast === 'function') toast('Sorry, this is sold out right now'); return; }
      if (added < items.length && typeof toast === 'function') toast((items.length - added) + (items.length - added > 1 ? ' items are' : ' item is') + ' sold out and left out of your order');
      if (typeof window.openTysloForm === 'function') {
        window.openTysloForm(true); brandBtn(); setTimeout(brandBtn, 600);
        var m = document.getElementById('easysell-modal'), t0 = Date.now();
        (function wait() { if ((m && m.style.display === 'block') || Date.now() - t0 > 4000) loading(false); else setTimeout(wait, 30); })();
      } else location.href = '/cart?easysell=1';
    }).catch(function () { busy = false; loading(false); if (typeof toast === 'function') toast('Something went wrong. Please try again.'); });
  };

  // Photos inside sideways rows (product row, add-ons, kits, reels, gallery thumbs) never load on their own:
  // the browser's lazy loading only sees what is on screen, so a swipe showed empty cards. Once the page has
  // loaded, a row near the screen loads its next few photos; the rest load as soon as the row is touched or scrolled.
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var SEL = '.track, .ao-track, #buy, .kits-grid, .rl-stage, #gal, .xrow, .steps', AHEAD = 4;
    var eager = function (root, n) { var l = root.querySelectorAll('img[loading="lazy"]'); for (var k = 0; k < l.length && k < n; k++) l[k].loading = 'eager'; };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target, all = false; io.unobserve(el); eager(el, AHEAD);
        var more = function () { all = true; eager(el, 1e3); };
        el.addEventListener('scroll', more, { capture: true, passive: true, once: true });
        el.addEventListener('pointerdown', more, { passive: true, once: true });
        new MutationObserver(function () { eager(el, all ? 1e3 : AHEAD); }).observe(el, { childList: true, subtree: true });
      });
    }, { rootMargin: '600px 0px' });
    var start = function () { document.querySelectorAll(SEL).forEach(function (el) { io.observe(el); }); };
    if (document.readyState === 'complete') start(); else addEventListener('load', start);
  })();

  // Theme editor: a re-rendered section comes back empty, so re-run the script that fills it.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target, has = function (id) { return s.querySelector('#' + id); }, run = function (name) { if (typeof window[name] === 'function') window[name](); };
      try {
        if (has('ticker')) run('csInitTicker');
        if (has('bstrip')) run('csInitBrandStrip');
        if (has('tabs')) { run('csInitTabs'); if (typeof pick === 'function') pick(current); }
        if (has('reels')) run('csInitReels');
        if (has('ba')) run('csInitBA');
        if (has('qzIn')) run('csInitQuiz');
        if (has('kitsHome') && typeof kitsHTML === 'function') has('kitsHome').outerHTML = kitsHTML();
        if (has('whyHome') && typeof compareHTML === 'function') has('whyHome').outerHTML = compareHTML({ duo: true });
        if (has('whyPdp') && typeof compareHTML === 'function') has('whyPdp').outerHTML = compareHTML({ title: has('whyPdp').dataset.title || 'Why buy it here?', wave: false });
      } catch (err) { console.error('[Clean Skin] section refresh', err); }
    });
  }

  // EasySell can also open by itself (/cart?easysell=1): brand its button once it exists.
  setTimeout(brandBtn, 2500);

  // /cart: the design's bag drawer is the cart UI; open it unless EasySell is taking over.
  if (/^\/cart\/?$/.test(location.pathname) && !/easysell=1/.test(location.search) && typeof openCart === 'function') {
    setTimeout(function () { try { openCart(); } catch (e) {} }, 300);
  }
})();
